import React, { Component } from 'react';
import { connect } from 'react-redux';
import { customerService } from '../../services';
import axios from 'axios';
import { CONTACTSTAFF_MESSAGE_TEXT } from '../../common/commonConstant';

class ContactStaff extends Component {
  componentDidMount() {
    this.checkCustomer();
  }

  componentDidUpdate(prevProps) {
    // เช็คว่า profile.userId เปลี่ยนแปลงหรือไม่
    if (this.props.profile.userId !== prevProps.profile.userId) {
      this.checkCustomer();
    }
  }

  checkCustomer() {
    const { profile } = this.props;
    if (profile?.userId) {
      customerService
        .get(profile.userId)
        .then((res) => {
          // ตรวจสอบข้อมูลที่ได้รับจาก API
          if (res && res._id) {
            const customerType = res.type;
            const uid = profile?.userId;
            const isValidCustomer = customerType === 'abo' || customerType === 'member';

            if (isValidCustomer) {
              // ถ้าเป็นลูกค้า (abo หรือ member)
              const params = {uid:uid, customer:res, customerType:customerType, text:CONTACTSTAFF_MESSAGE_TEXT, type:"MESSAGE"};
              axios.post(`${process.env.REACT_APP_API_URL}/utils/livechatshowdept`, params);
                window.location.replace('line://ti/p/@amwaythailand');
            } else {
              // ถ้าไม่ใช่ลูกค้า
              window.location.replace('line://ti/p/@amwaythailand');
            }
          } else {
            // ไม่พบข้อมูลลูกค้า
            window.location.replace('line://ti/p/@amwaythailand');
          }
        })
        .catch((err) => {
          // ถ้าเกิด error
          window.location.replace('line://ti/p/@amwaythailand');
        });
    }
  }

  render() {
    return null;
  }
}

const mapStateToProps = (state) => ({
  profile: state.profile,
});

export default connect(mapStateToProps)(ContactStaff);

